import { render, staticRenderFns } from "./CalendarCategories.vue?vue&type=template&id=6531aaf6"
import script from "./CalendarCategories.vue?vue&type=script&lang=js"
export * from "./CalendarCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports